/* eslint-disable */
// import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
  verifyowner:'',
  platimg:[],
  editPropertyCategory:'',//修改或复制付款时的首次渲染的楼盘类型
  propertyCategory:"",//当前的楼盘类型
  rentalType:'',//当前租售类型
  mode:'',
  tagsConfig:{
    propertyCategory:"",//记录每一次点击确认时标签页对应的楼盘类型
  },
  // plan:0,//回显显示平面图数
  tagcount:0,//回显显示选中标签数
  propertyTags:[],//上传接口数据(index页面用)
  tags:[],//回显时需要数据(tags页面用)
  rentText:'',
  videos:[],
  images: [],
  verifyImage: [],
  yezhuverifyImage:[],
  estateInfo: {},
  estatePhase: [],
  estateBuildNum: [],
  estateBuildNumByPhase: [],
  wordsList:[],
  introduceWords:[],
  enwordsList:[],
  enintroduceWords:[],
  phaseText: '',
  phaseWarpData: null,
  buildText: '',
  buildId: '',
  floorData: [],
  selectFloorData: '',
  floorText: '',
  roomNoWithCulture: '',
  UnitFloorText: '',
  estateData: {},
  phaseData: {},
  unitFloorData: {},
  selectRoomNoData: {},
  firstSelectBuild: false,
  isBackFlag: false,
  unitImage: [],
  floUrl: [],
  roomNumberText: '',
  roomNumberData: {},
  toiletNumberText: '',
  toiletNumberData: {},
  categoryTypeData: ''
};
const getters = {};
const mutations = {
  setRentalType(state,data){
    state.rentalType=data
  },
  setEditCate(state,data){
    state.editPropertyCategory=data.editPropertyCategory
  },
  setverifyowner(state,data){
    state.yezhuverifyImage = data
  },
  setTagsCount(state,data){
    state.tagcount=data
  },
  setTagsConfig(state,data){
    // state.tagsConfig.propertyCategory=data.propertyCategory
    state.propertyTags=data.propertyTags

  },
  // 面积保存
  setsaleableArea(state,data){
    state.saleableArea=data.saleableArea
  },
  //保存mode
  setmode(state,data){
    state.mode=data.mode
  },
  //平面图保存的数据
  setplatimg(state,data){
    state.platimg=data.platimg
  },
  setProCate(state,data){
    state.tagsConfig.propertyCategory=data.propertyCategory
  },
  setTags(state,data){
    state.tags=data
  },
  setRentText(state,data){
    state.rentText=data
  },
  setCategory(state,data){
    state.propertyCategory=data.warpData
    // state.mode=data.mode
  },
  setenWordsList(state,data){
    state.enwordsList=data
  },
  setenIntroduce(state,data){
    localStorage.setItem("enintroduceWords",state.enintroduceWords.concat(data))
    state.enintroduceWords=data
  },
  setIntroduce(state,data){
    state.introduceWords=data
  },
  setWordsList(state,data){
    state.wordsList=data
  },
  setImages (state, data) {
    state.images = data;
  },
  setverImages (state, data) {
    state.verifyImage = data;
  },
  setEstate (state, data) {
    state.estateInfo = data;
  },
  setPhase (state, data) {
    state.estatePhase = data;
  },
  setEstateData(state, data) {
    state.estateData = data
  },
  // 存储期数选中的数据
  setPhaseData(state, data) {
    state.phaseData = data
  },
  // 存储座数数据
  setBuildNum(state, data) {
    state.estateBuildNum = data
  },
  // 根据选择的期数来存储座数数据
  setBuildNumByPhase(state, data) {
    state.estateBuildNumByPhase = data
  },
  // 存储期数选择后的数据
  setPhaseSelectText(state, data) {
    state.phaseText = data
  },
  // 存储座数选择后的数据
  setBuildSelectText(state, data) {
    state.buildText = data
  },
  // 存储座数选择后的全部数据
  setBuildSelectId(state, data) {
    state.buildId = data
  },
  // 期数选择的数据
  setPhaseWarpData(state, data) {
    state.phaseWarpData = data
  },
  // 存储楼层数据
  setFloorData(state, data) {
    state.floorData = data
  },
  // 存储选中的楼层数据
  setSelectFloorData(state, data) {
    state.selectFloorData = data
  },
  setSelectRoomNoData(state, data) {
    state.selectRoomNoData = data
  },
  // 存储楼层选择后的全部数据
  setFloorSelectText(state, data) {
    state.floorText = data
  },
  setUnitFloorData(state, data) {
    state.unitFloorData = data
  },
  // 存储单位选择后的全部数据
  setroomNoWithCulture(state, data) {
    state.roomNoWithCulture = data
  },
  // 存储高低层选择后的数据
  setUnitFloorSelctText(state, data) {
    state.UnitFloorText = data
  },
  setVideoimg(state,data){
    state.videos=data
  },
  setFirstSelectBuild(state, data) {
    state.firstSelectBuild = data
  },
  setIsBackFlag(state, data) {
    state.isBackFlag = data;
  },
  // 单位平面图数据
  setUnitImage(state, data) {
    state.unitImage = data
  },
  // 楼层平面图数据
  setFloUrl(state, data) {
    state.floUrl = data
  },
  // 选择房间数目后的text数据
  setRoomNumberText(state, data) {
    state.roomNumberText = data
  },
  // 选择房间数目后的data数据
  setRoomNumberData(state, data) {
    state.roomNumberData = data
  },
  // 选择洗手间数目后的text数据
  setToiletNumberText(state, data) {
    state.toiletNumberText = data
  },
  // 选择洗手间数目后的data数据
  setToiletNumberData(state, data) {
    state.toiletNumberData = data
  },
  // 楼盘类型数据
  setCategoryType(state, data) {
    state.categoryTypeData = data
  },
  clearStore (state) {
    state.roomNumberText = ''
    state.roomNumberData = {}
    state.toiletNumberText = ''
    state.toiletNumberData = {}
    state.images = [];
    state.verifyImage = [];
    state.yezhuverifyImage = [];
    state.estateInfo = {};
    state.estatePhase = [];
    state.estateBuildNum = [];
    state.estateBuildNumByPhase = [];
    state.videos=[];
    state.tags=[];
    state.platimg = [];
    state.phaseText = '';
    state.phaseWarpData = null,
    state.buildText = '',
    state.buildId = '',
    state.floorData = [],
    state.selectFloorData = '',
    state.floorText = '',
    state.roomNoWithCulture = '',
    state.UnitFloorText = '',
    state.estateData = {},
    state.phaseData = {},
    state.unitFloorData = {},
    state.selectRoomNoData = {}
  }
};
const actions = {};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});

export default store;
